import BaseFactory from 'services/sports/default/base-factory';
import PlayerClassic from './player-classic';
import PlayerSinglegame from './player-singlegame';
import Const from 'constants';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: PlayerClassic,
    [Const.GAME_TYPE_SINGLEGAME]: PlayerSinglegame,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
